import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const BillsApi = createApi({
  reducerPath: "bills",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["Bills"],
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      createBills: builder.mutation({
        query: (data) => apiFunction(data, `/api/bills/storageRoles/createBill`, "POST"),
        invalidatesTags: ["Bills"],
      }),
      controllBills: builder.mutation({
        query: (data) => apiFunction(data, `/api/bills/storageRoles/controllBill`, "PATCH"),
      }),
      deleteBill: builder.mutation({
        query: (data) => apiFunction(data, `/api/bills/storageRoles/delete`, "DELETE"),
        invalidatesTags: ["Bills"],
      }),
      getBills: builder.query({
        query: (data) => apiFunction(data, `/api/bills/storageRoles/getMyBills`, "POST"),
        providesTags: ["Bills"],
      }),
      // Satış dashboard'u — tüm firmalar üzerinden ciro/kota kırılımı.
      // Agregasyon server'da yapılır, buraya sadece özet iner.
      getSalesSummary: builder.query({
        query: (data) => apiFunction(data, `/api/bills/storageRoles/salesSummary`, "POST"),
        providesTags: ["Bills"],
      }),
    };
  },
});

export const {
  useCreateBillsMutation,
  useGetBillsQuery,
  useGetSalesSummaryQuery,
  useLazyGetBillsQuery,
  useControllBillsMutation,
  useDeleteBillMutation,
} = BillsApi;
export { BillsApi };
